import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'z-toaster',
  standalone: true,
  imports: [ToastModule, RouterModule],
  templateUrl: './toaster.component.html',
  styleUrl: './toaster.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToasterComponent {
  private readonly messageService = inject(MessageService);

  closeMessage(): void {
    this.messageService.clear('toast-prime-component');
  }
}
